import React from 'react';

import {Alert} from '@ui';

// TODO: Proper MUI icon should be added
const UsersTableMessage = () => (
    <Alert severity='info'>
        AV-CMP uses Sportradar Common-IAM as authentication system.<br />
        Please use the form below to search in the Common-IAM database for the user to be added.
    </Alert>
);

export default UsersTableMessage;
